import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type DisableWebhookMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.DisableWebhookInput;
}>;

export type DisableWebhookMutationResult = { __typename?: 'Mutation' } & {
  webhookSubscriptionsDisableWebhook?: GraphQLTypes.Maybe<
    { __typename?: 'DisableWebhookPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const DisableWebhookDocument = gql`
  mutation disableWebhook($input: DisableWebhookInput!) {
    webhookSubscriptionsDisableWebhook(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
